<section class="flex flex-column consult__section">
  <div class="inline-flex align-items-center justify-content-between consult__section-subheading-group">
    <h2 class="col-8 pl-0 consult__section-subheading">
      <label for="oral-health_{{turn}}" class="field__label no-margin">{{screen.labels.oralHealth.heading}}</label>
    </h2>
    <h2 class="col-4 pr-0 consult__section-subheading">
      <label for="oral-hygiene_{{turn}}" class="field__label no-margin">{{screen.labels.oralHygiene.heading}}</label>
    </h2>
  </div>

  <div class="oral-health-view__wrapper">
    <div id="oral-health-view" class="oral-health-view">
      <div class="col-12 px-0 inline-flex" [class.readonly]="readonly">
        <div class="col-4 pl-0 inline-flex flex-column">
          <div class="col-12 px-0 py-0 inline-flex oral-health__wrapper" *ngIf="value">
            <span class="col text-center strong">
              {{screen.labels.oralHealth.teeth}}
            </span>
            <span class="col-fixed text-center strong" [style.width.px]="55"
              [pTooltip]="screen.labels.oralHealth.plaque">
              P
            </span>
            <span class="col-fixed text-center strong" [style.width.px]="55"
              [pTooltip]="screen.labels.oralHealth.calc">
              C
            </span>
            <span class="col-fixed text-center strong" [style.width.px]="55"
              [pTooltip]="screen.labels.oralHealth.gingivitis">
              G
            </span>
          </div>

          <div class="col-12 px-0 py-0 inline-flex oral-health__wrapper" *ngFor="let item of hygiene">
            <span class="col px-0 py-0 inline-flex text-center">
              <span class="col-4 oral-health__hygiene-part" [class.active]="item.partNumber01"
                (click)="handleSelectPart(item, '01')">{{item.part1}}</span>
              <span class="col-4 oral-health__hygiene-part" [class.active]="item.partNumber02"
                (click)="handleSelectPart(item, '02')">{{item.part2}}</span>
              <span class="col-4 oral-health__hygiene-part" [class.active]="item.partNumber03"
                (click)="handleSelectPart(item, '03')">{{item.part3}}</span>
            </span>
            <span class="col-fixed text-center oral-health__hygiene-value" [style.width.px]="55"
              (click)="addValueToPlaque(item)">
              {{item.plaque}}
            </span>
            <span class="col-fixed text-center oral-health__hygiene-value" [style.width.px]="55"
              (click)="addValueToCalc(item)">
              {{item.calc}}
            </span>
            <span class="col-fixed text-center oral-health__hygiene-value" [style.width.px]="55"
              (click)="addValueToGingivitis(item)">
              {{item.gingivitis}}
            </span>
          </div>

          <div class="col-12 px-0 py-0 inline-flex oral-health__wrapper">
            <span class="col text-center strong">
              {{screen.labels.oralHealth.totals}}
            </span>
            <span class="col-fixed text-center oral-health__hygiene-value" [style.width.px]="55">
              {{getPlaqueTotal}}
            </span>
            <span class="col-fixed text-center oral-health__hygiene-value" [style.width.px]="55">
              {{getCalcTotal}}
            </span>
            <span class="col-fixed text-center oral-health__hygiene-value" [style.width.px]="55">
              {{getGingivitisTotal}}
            </span>
          </div>
        </div>

        <div class="col-4 px-0 inline-flex flex-column">
          <div class="col-12 px-0 py-0 inline-flex align-items-center oral-health__wrapper" *ngIf="value">
            <span class="col-4 text-center strong">
              {{screen.labels.oralHealth.periodontalDisease}}
            </span>
            <span class="col-4 text-center strong">
              {{screen.labels.oralHealth.badOcclusion}}
            </span>
            <span class="col-4 text-center strong">
              {{screen.labels.oralHealth.fluorosis}}
            </span>
          </div>

          <div class="col-12 px-0 py-0 inline-flex oral-health__wrapper" *ngIf="value">
            <div class="col-4 px-0 py-0 inline-flex flex-column">
              <div class="col-12 inline-flex align-items-center">
                <p-radioButton name="periodontalDisease" value="0" [(ngModel)]="value.periodontalDisease"
                  [label]="screen.labels.oralHealth.none" [disabled]="readonly"></p-radioButton>
              </div>
              <div class="col-12 inline-flex align-items-center">
                <p-radioButton name="periodontalDisease" value="1" [(ngModel)]="value.periodontalDisease"
                  [label]="screen.labels.oralHealth.low" [disabled]="readonly"></p-radioButton>
              </div>
              <div class="col-12 inline-flex align-items-center">
                <p-radioButton name="periodontalDisease" value="2" [(ngModel)]="value.periodontalDisease"
                  [label]="screen.labels.oralHealth.mid" [disabled]="readonly"></p-radioButton>
              </div>
              <div class="col-12 inline-flex align-items-center">
                <p-radioButton name="periodontalDisease" value="3" [(ngModel)]="value.periodontalDisease"
                  [label]="screen.labels.oralHealth.high" [disabled]="readonly"></p-radioButton>
              </div>
            </div>

            <div class="col-4 px-0 py-0 inline-flex flex-column">
              <div class="col-12 inline-flex align-items-center">
                <p-radioButton name="badOcclusion" value="0" [(ngModel)]="value.badOcclusion"
                  [label]="screen.labels.oralHealth.none" [disabled]="readonly"></p-radioButton>
              </div>
              <div class="col-12 inline-flex align-items-center">
                <p-radioButton name="badOcclusion" value="1" [(ngModel)]="value.badOcclusion"
                  [label]="screen.labels.oralHealth.level1" [disabled]="readonly"></p-radioButton>
              </div>
              <div class="col-12 inline-flex align-items-center">
                <p-radioButton name="badOcclusion" value="2" [(ngModel)]="value.badOcclusion"
                  [label]="screen.labels.oralHealth.level2" [disabled]="readonly"></p-radioButton>
              </div>
              <div class="col-12 inline-flex align-items-center">
                <p-radioButton name="badOcclusion" value="3" [(ngModel)]="value.badOcclusion"
                  [label]="screen.labels.oralHealth.level3" [disabled]="readonly"></p-radioButton>
              </div>
            </div>

            <div class="col-4 px-0 py-0 inline-flex flex-column">
              <div class="col-12 inline-flex align-items-center">
                <p-radioButton name="fluorosis" value="0" [(ngModel)]="value.fluorosis"
                  [label]="screen.labels.oralHealth.none" [disabled]="readonly"></p-radioButton>
              </div>
              <div class="col-12 inline-flex align-items-center">
                <p-radioButton name="fluorosis" value="1" [(ngModel)]="value.fluorosis"
                  [label]="screen.labels.oralHealth.low" [disabled]="readonly"></p-radioButton>
              </div>
              <div class="col-12 inline-flex align-items-center">
                <p-radioButton name="fluorosis" value="2" [(ngModel)]="value.fluorosis"
                  [label]="screen.labels.oralHealth.mid" [disabled]="readonly"></p-radioButton>
              </div>
              <div class="col-12 inline-flex align-items-center">
                <p-radioButton name="fluorosis" value="3" [(ngModel)]="value.fluorosis"
                  [label]="screen.labels.oralHealth.high" [disabled]="readonly"></p-radioButton>
              </div>
            </div>
          </div>
        </div>

        <div class="col-4 pr-0 inline-flex flex-column">
          <div class="col-12 px-0 py-0 inline-flex oral-health__wrapper" *ngIf="value">
            <div class="col-fixed inline-flex align-items-center" [style.width.px]="30">D</div>
            <div class="col-fixed inline-flex align-items-center flex-column" [style.width.px]="70">
              <label class="oral-health__label">C</label>
              <input pInputText type="number" name="oral-health__C_{{turn}}" [(ngModel)]="value.cpoC" class="no-margin"
                [readonly]="readonly" validation />
            </div>
            <div class="col-fixed inline-flex align-items-center flex-column" [style.width.px]="70">
              <label class="oral-health__label">P</label>
              <input pInputText type="number" name="oral-health__P_{{turn}}" [(ngModel)]="value.cpoP" class="no-margin"
                [readonly]="readonly" validation />
            </div>
            <div class="col-fixed inline-flex align-items-center flex-column" [style.width.px]="70">
              <label class="oral-health__label">O</label>
              <input pInputText type="number" name="oral-health__O_{{turn}}" [(ngModel)]="value.cpoO" class="no-margin"
                [readonly]="readonly" validation />
            </div>
            <div class="col inline-flex align-items-center flex-column">
              <label class="oral-health__label">Total</label>
              <input pInputText type="text" name="oral-health__cpo_{{turn}}" [value]="calculateCPO" class="no-margin"
                readonly />
            </div>
          </div>

          <div class="col-12 px-0 py-0 inline-flex oral-health__wrapper" *ngIf="value">
            <div class="col-fixed inline-flex align-items-center" [style.width.px]="30">d</div>
            <div class="col-fixed inline-flex align-items-center flex-column" [style.width.px]="70">
              <label class="oral-health__label">c</label>
              <input pInputText type="number" name="oral-health__c_{{turn}}" [(ngModel)]="value.ceoC" class="no-margin"
                [readonly]="readonly" validation />
            </div>
            <div class="col-fixed inline-flex align-items-center flex-column" [style.width.px]="70">
              <label class="oral-health__label">e</label>
              <input pInputText type="number" name="oral-health__e_{{turn}}" [(ngModel)]="value.ceoE" class="no-margin"
                [readonly]="readonly" validation />
            </div>
            <div class="col-fixed inline-flex align-items-center flex-column" [style.width.px]="70">
              <label class="oral-health__label">o</label>
              <input pInputText type="number" name="oral-health__o_{{turn}}" [(ngModel)]="value.ceoO" class="no-margin"
                [readonly]="readonly" validation />
            </div>
            <div class="col inline-flex align-items-center flex-column">
              <label class="oral-health__label">Total</label>
              <input pInputText type="text" name="oral-health__ceo_{{turn}}" [value]="calculateCEO" class="no-margin"
                readonly />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>